console.log("BASE URL FRONT:", axios.defaults.baseURL);

import { useEffect, useState } from "react";
import axios from "../../api/axios.js";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../../styles/theme-dark.css";

/* ================================
   ESTILOS GLASS
================================ */
function glass(extra = {}) {
  return {
    background: "rgba(15,23,42,0.75)",
    borderRadius: 14,
    border: "1px solid rgba(148,163,184,0.45)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
    ...extra,
  };
}

/* ================================
   COMPONENTE PRINCIPAL
================================ */
export default function Tecnicos() {
  const [instalaciones, setInstalaciones] = useState([]);
  const [satResumen, setSatResumen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState("todas");

  const navigate = useNavigate();
  const location = useLocation();

  /* ----- Sincronizar instalaciones ----- */
async function sincronizarInstalacionesDesdePresupuestos() {
  try {
    const r = await axios.get("/presupuestos");
    const presupuestos = r.data?.data || [];

    for (const p of presupuestos) {
      // Solo presupuestos válidos
      if (p.estado !== "aceptado" && p.estado !== "facturado") {
        continue;
      }

      // Comprobar si ya existe instalación
      let existentes = [];
      try {
        const ex = await axios.get(
          `/instalaciones/por-presupuesto/${p.id}`
        );
        existentes = Array.isArray(ex.data)
          ? ex.data
          : ex.data?.data || [];
      } catch {
        existentes = [];
      }

      if (existentes.length > 0) {
        continue; // ya existe → no hacer nada
      }

      // Intentar generar instalación
      try {
        const gen = await axios.post(
          `/instalaciones/auto-generar/${p.id}`
        );

        // Si backend responde success:false, NO es error
        if (gen.data?.success === false) {
          console.warn(
            `Instalación no creada para presupuesto ${p.id}:`,
            gen.data.message
          );
        }
      } catch (e) {
        console.error(
          `Error real generando instalación para presupuesto ${p.id}:`,
          e.response?.data || e.message
        );
      }
    }
  } catch (err) {
    console.error("Error sincronizando instalaciones:", err);
  }
}


  /* ----- Cargar instalaciones + SAT ----- */
  async function cargarDatos() {
    try {
      setLoading(true);

      

const [resInst, resSat] = await Promise.all([
  axios.get("/instalaciones"),
  axios.get("/sat/resumen"),
]);





      setInstalaciones(resInst.data || []);
      setSatResumen(resSat.data || []);
    } catch (err) {
      console.error("Error cargando técnicos:", err);
    } finally {
      setLoading(false);
    }
  }

  const marcarParaInstalar = async (instalacionId) => {
  try {
    await axios.post(`/instalaciones/${instalacionId}/marcar-instalacion`);
    await cargarDatos(); // refresca lista
  } catch (error) {
    console.error("Error marcando instalación:", error);
  }
};


  /* 🔁 RECARGA AUTOMÁTICA */
  useEffect(() => {
    async function init() {
      await sincronizarInstalacionesDesdePresupuestos();
      await cargarDatos();
    }
    init();
  }, [location.pathname]);

  /* ----- Helper SAT ----- */
function getSatEstado(instalacionId) {
  const r = satResumen.find(
    (s) => s.instalacionId === instalacionId
  );

  const total = Number(r?.total ?? 0);
  const abiertas = Number(r?.abiertas ?? 0);

  return {
    total,
    tieneAbiertas: abiertas > 0,
  };
}


  /* ----- Filtrado ----- */
const instalacionesFiltradas = instalaciones
  .filter((i) => {
    if (filtro === "todas") return true;
    if (filtro === "instalaciones") return i.marcar_instalacion === true;
    if (filtro === "pendientes") return i.estado_instalacion === "pendiente";
    if (filtro === "instaladas") return i.estado_instalacion === "instalado";
    if (filtro === "firmadas") return i.estado_firma === "firmado";
    

    if (filtro === "incidencias") {
      const sat = getSatEstado(i.id);
      return sat && sat.tieneAbiertas;
    }

    return true;
  })
  .sort((a, b) => {
    // 🔥 más reciente primero
    return (b.id || 0) - (a.id || 0);
  });


  if (loading) {
    return (
      <div className="page-dark" style={{ padding: 20 }}>
        Cargando módulo técnicos…
      </div>
    );
  }

  return (
    <div className="page-dark" style={{ padding: 16 }}>
      {/* HEADER */}
      <header
        style={{
          padding: "18px 22px",
          marginBottom: 18,
          background: "rgba(15,23,42,0.65)",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
          borderRadius: "0 0 16px 16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
            Técnicos
          </h1>
          <p style={{ opacity: 0.7, marginTop: 4, fontSize: 13 }}>
            Panel central de envíos, instalaciones, firmas, incidencias y auditoría.
          </p>
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          <Link to="/tecnicos/checklists" className="glass-btn" style={{ fontSize: 13 }}>
            📋 Checklists
          </Link>
          <Link to="/dashboard" className="glass-btn" style={{ fontSize: 13 }}>
            ← Volver al panel
          </Link>
        </div>
      </header>

      {/* FILTROS */}
      <div style={glass({ padding: 10, marginBottom: 16 })}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {[
            ["todas", "Todas"],
  ["instalaciones", "Instalaciones"],
  ["pendientes", "Pendientes"],
  ["instaladas", "Instaladas"],
  ["firmadas", "Firmadas"],
  ["incidencias", "Con incidencias abiertas"],
          ].map(([value, label]) => (
            <button
              key={value}
              onClick={() => setFiltro(value)}
              style={{
                padding: "8px 14px",
                borderRadius: 10,
                fontSize: 13,
                border: "none",
                cursor: "pointer",
                background:
                  filtro === value
                    ? "rgba(59,130,246,0.35)"
                    : "rgba(255,255,255,0.05)",
                color: "white",
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

<TablaTecnicos
  instalaciones={instalacionesFiltradas}
  navigate={navigate}
  getSatEstado={getSatEstado}
  marcarParaInstalar={marcarParaInstalar}
/>

    </div>
  );
}

/* ================================
   TABLA PRINCIPAL
================================ */
function TablaTecnicos({
  instalaciones,
  navigate,
  getSatEstado,
  marcarParaInstalar,
}) {

  return (
    <div style={glass({ padding: 14 })}>
      {instalaciones.length === 0 ? (
        <p style={{ opacity: 0.7, fontSize: 13 }}>
          No hay instalaciones registradas.
        </p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ opacity: 0.7 }}>
                <th style={{ padding: 6 }}>Número</th>
                <th style={{ padding: 6 }}>Fecha</th>
                <th style={{ padding: 6 }}>Cliente</th>
                <th style={{ padding: 6 }}>Referencia</th>

                <th style={{ padding: 6 }}>Presupuesto</th>
                <th style={{ padding: 6 }}>Envío</th>
                <th style={{ padding: 6 }}>Instalación</th>
                <th style={{ padding: 6 }}>Firma</th>
                <th style={{ padding: 6 }}>Incidencias</th>
                <th style={{ padding: 6 }}>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {instalaciones.map((i) => {
                const sat = getSatEstado(i.id);
                const color = sat?.tieneAbiertas ? "#ef4444" : "#22c55e";

                return (
                  <tr key={i.id}>
                    <td style={{ padding: 6 }}>{i.numero || i.id}</td>
                    <td style={{ padding: 6 }}>
  {i.presupuesto?.fechaAceptacion
    ? new Date(i.presupuesto.fechaAceptacion).toLocaleDateString("es-ES")
    : "-"}
</td>

                    <td style={{ padding: 6 }}>{i.clienteNombre}</td>
                    <td style={{ padding: 6 }}>  {i.nombre_referencia || "—"}</td>
                    <td style={{ padding: 6 }}>  {i.presupuesto?.numero || "-"}</td>


                    <td style={{ padding: 6 }}>{renderEstado(i.estado_envio)}</td>
                    <td style={{ padding: 6 }}>{renderEstado(i.estado_instalacion)}</td>
                    <td style={{ padding: 6 }}>{renderEstado(i.estado_firma)}</td>

                    <td style={{ padding: 6 }}>
                      {sat ? (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            fontWeight: 600,
                            color,
                          }}
                        >
                          <span
                            style={{
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor: color,
                            }}
                          />
                          {sat.total}
                        </span>
                      ) : (
                        "—"
                      )}
                    </td>

                    <td
  style={{
    padding: 6,
    display: "flex",
    gap: 8,
    justifyContent: "center",
  }}
>
  <button
    className="btn-mini"
    onClick={() => navigate(`/tecnicos/informe/${i.id}`)}
  >
    ✏️
  </button>

  <button
    className="btn-mini"
    onClick={() => navigate(`/sat/${i.id}`)}
    title="SAT"
  >
    🛠️
  </button>

<button
  className="btn-mini"
  title={
    i.marcar_instalacion
      ? "Quitar de instalaciones"
      : "Marcar para instalar"
  }
  onClick={() => marcarParaInstalar(i.id)}
  style={{
    background: i.marcar_instalacion
      ? "rgba(34,197,94,0.35)"   // verde
      : "rgba(255,255,255,0.08)",
    color: i.marcar_instalacion ? "#22c55e" : "#fff",
    fontWeight: 700,
  }}
>
  {i.marcar_instalacion ? "✅" : "📌"}
</button>

</td>


                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

/* ================================
   ESTADOS VISUALES
================================ */
function renderEstado(estado) {
  if (!estado) return "—";

  const colors = {
    pendiente: "🟡 pendiente",
    enviado: "🔵 enviado",
    instalado: "🟢 instalado",
    firmado: "🟣 firmado",
    error: "🔴 error",
  };

  return colors[estado] || estado;
}
